/**
 * The login screen is mounted at "/" (see App.tsx) — there is no "/login"
 * route component. Every redirect back to the login screen goes through this
 * constant: sending users to "/login" left them on a path that matched no
 * route, so a logout showed a blank screen before something else bounced them
 * to the real page.
 */
export const LOGIN_ROUTE = '/';

/** Path other services and old bookmarks still point at; aliased to LOGIN_ROUTE. */
export const LEGACY_LOGIN_ROUTE = '/login';

/**
 * Vendor sign-in — mobile number + OTP. Vendors hold no platform password, so
 * they get their own screen rather than a second mode on the employee form.
 */
export const VENDOR_LOGIN_ROUTE = '/vendor-login';

/** Static privacy policy — public, readable whether or not the user is signed in. */
export const PRIVACY_POLICY_ROUTE = '/privacy';
